<template>
  <div class="flex gap-1 bg-dark4 bg-opacity-5 p-1 rounded-sm">
    <div
      v-for="option in options"
      :key="option.id"
      class="rounded-sm text-md md:px-[6px] px-1 flex justify-center items-center"
      role="radio"
      data-testId="radio"
      :class="{
        'bg-white': model === option.name
      }"
      tabindex="0"
      :aria-checked="model === option.name"
      @click="selectOption(option.name)"
      @keydown.space.prevent="onKeyPress($event, option.name)"
      @keydown.enter.prevent="onKeyPress($event, option.name)"
    >
      <label
        :for="option.id"
        class="cursor-pointer md:text-md text-xs"
        :class="{
          'text-dark2': model === option.name,
          'text-dark4': model !== option.name
        }"
        >{{ option.label }}</label
      >
      <input
        :id="option.id"
        v-model="model"
        type="radio"
        :name="option.name"
        class="hidden"
        :value="option.name"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  type Option = {
    id: string;
    name: string;
    label: string;
  };

  interface RadioGroupProps {
    id: string;
    name: string;
    options: Option[];
  }

  defineProps<RadioGroupProps>();

  const model = defineModel<string>();
  const selectOption = (value: string) => {
    model.value = value;
  };

  const onKeyPress = (event: KeyboardEvent, value: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      selectOption(value);
    }
  };
</script>
